import React, { Component } from "react"
import { m } from '../../utils';
import './index.css';
import Calendar from '../../artzu-ui/src/Calendar'
import Button from '../../artzu-ui/src/Button'
import Modal from '../../artzu-ui/src/Modal'
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

class BookingCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cursor: null,
      showOrientation: this.props.newBookingOrientation,
    };
  }
  
  render() {
    const {
      cursor
    } = this.state;
    const {
      tier,
      rate,
      shiftStart,
      shiftEnd,
      selectedShifts,
      addShiftToSelection,
      flexible,
      bookModal,
      nextMonth,
      prevMonth,
      currentMonth,
      bookedDates,
      prices,
      flexibleDates,
      formatShift,
      userBookings,
      unavailableModal,
      showUnavailableModal,
      hideOrientation,
      handleHideOrientation,
      parkinglotId
    } = this.props;
    return (
      <div className="calendar-book">
        {bookModal()}
        {unavailableModal()}
        {this.orientationModal()}
        <Calendar
          className="artzu-calendar"
          currentMonth={currentMonth}
          nextMonth={nextMonth}
          prevMonth={prevMonth}
          onDateSelect={date => {
            let availability = prices[new Date(date).toDateString()]
            if (availability && !availability.flexible) {
              addShiftToSelection(date.toDate(), m(availability.startTime), m(availability.endTime), tier, availability.price, availability.shiftRates, parkinglotId)
              return 'select'
            } else if (availability && availability.flexible === flexible) {
              this.setCursor(date.toDate().toDateString());
              return 'suggest'
            } else {
              let existingBookings = [
                userBookings[date.subtract(1, 'day').toDate().toDateString()], 
                userBookings[date.toDate().toDateString()], 
                userBookings[date.add(1, 'day').toDate().toDateString()]
              ].flat().filter(Boolean);
              let conflicts = existingBookings && existingBookings.filter(booking => {
                return (m(booking.startTime).isSameOrBefore(m(date).hour(shiftStart)) && m(booking.endTime).isSameOrAfter(m(date).hour(shiftStart))) ||
                  (m(booking.startTime).isSameOrBefore(m(date).hour(shiftEnd)) && m(booking.endTime).isSameOrAfter(m(date).hour(shiftEnd))) ||
                  (m(booking.startTime).isSameOrBefore(m(date).hour(shiftStart)) && m(booking.endTime).isSameOrAfter(m(date).hour(shiftEnd))) ||
                  (m(booking.startTime).isSameOrAfter(m(date).hour(shiftStart)) && m(booking.endTime).isSameOrBefore(m(date).hour(shiftEnd)))
              })
              if(date.hour(shiftStart).isBefore(m().add(15, 'minute'))) {
                showUnavailableModal(`You cannot make a booking in the past. All bookings must be made at least 15 minutes in advance before the start time.`)
              } else if(conflicts && conflicts.length > 0) {
                showUnavailableModal("This booking is unavailable because it conflicts with one of your existing bookings.")
              } else {
                showUnavailableModal("This booking is unavailable because it is fully booked.")
              }
              return false
            }
          }}
          onChangeMonth={month => {}}
          selectedShifts={selectedShifts.map(shift => shift.date)}
          flexibleDates={flexibleDates}
          selectedColor="#128dff"
          todayColor="#128dff"
          accordionColor="#414141"
          available={prices}
          ancestor="book"
          renderDay={day => {
            return (
              <div
                className={
                  prices[day.toDate().toDateString()] &&
                  prices[day.toDate().toDateString()].price < rate[tier]
                  ? "blueish calendar-mark" : " calendar-mark"
                }  
                >
                  {
                    bookedDates.find(booked => day.isSame(booked, "day")) ? 
                    <FontAwesomeIcon icon={faCircle} style={{ fontSize: "6px", color: "#414141", marginRight: prices[day.toDate().toDateString()] ? "2px" : "0"}} />
                    : null }
                  {prices[day.toDate().toDateString()] ? 
                      ` $${prices[day.toDate().toDateString()].price}` : 
                      " "}
              </div>
              )
          }}>
          {cursor && prices[cursor] ? 
          <div className="book-accordion">
          <p id="flex-msg">Your preferred time is not available. Other options:</p>
          <div className="button-div">
            <Button 
              className="accordion-button"
              size="xl"
              radius="15px"
              margin="0"
              primary={selectedShifts.find(shift => shift.date.toDateString() === cursor)}
              color={selectedShifts.find(shift => shift.date.toDateString() === cursor) ? "#128dff" : "#414141"}
              label={
                <div className="accordion-label">
                  <p className="accordion-row-1" style={{ fontWeight: '500' }}>{formatShift(m(prices[cursor].startTime).hour())} to {formatShift(m(prices[cursor].endTime).hour())}</p>
                  <p className="accordion-row-2" style={{ fontWeight: '500' }}>
                    <span style={{ fontWeight: '500' }}>{tier.toUpperCase()}</span>
                    <span style={{ fontWeight: '500' }}>${prices[cursor].price.toFixed(2)}</span>
                  </p>
                </div>
              } 
              onClick={() => {
                let availability = prices[cursor]
                addShiftToSelection(new Date(cursor), m(availability.startTime), m(availability.endTime), tier, availability.price, availability.shiftRates, parkinglotId)
              }}
            />
            <Button
              className="accordion-button waitlist-button"
              size="xl"
              radius="15px"
              margin="0"
              color="#414141"
              disabled
                  label={<div className="accordion-label"><p>+ Waitlist</p></div>}
            />
          </div>
          </div> : null}
        </Calendar>
      </div>
    )
  }

  orientationModal = () => (
    <Modal open={this.state.showOrientation && !this.props.hideOrientation}>
      <div className="unavailable-modal">
        <p>
          Click on the dates you want, then press the Confirm button to review your selection.
        </p>
        <Button 
          color="#414141" 
          className="cancel-butt" 
          margin="1em 0 0 0" 
          onClick={() => { 
            this.setState({ showOrientation: false})
            this.props.handleHideOrientation();
          }} label="Got it" />
      </div>
    </Modal>
  )

  setCursor = dateString => {
    this.setState({ cursor: dateString })
  }
}

export default BookingCalendar;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingCalendar.js